import { take } from "../util";
export const AppContext = Object.freeze({
    APP: 'APP',
    BOX_OFFICE: 'BOX_OFFICE',
    CHECKOUT: 'CHECKOUT',
    TICKETBUYER: 'TICKETBUYER',
    PUBLIC_API: 'PUBLIC_API',
});
export const fromGql = (gqlItem) => (Object.assign({}, (take(gqlItem, 'id', 'name', 'applicationId', 'appContext', 'urlBase', 'origin', 'enforceOrigin'))));
export const fromGqlCollection = (items) => (items === null || items === void 0 ? void 0 : items.map(fromGql)) || [];
//# sourceMappingURL=AppConfig.js.map